export const actions = {
    async otros({ commit, dispatch, state }, data) {
        let f = {
            api: `unidades?filters[empresa][$eq]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_unidades', r)

    },


}